import edataUserApi from './edataUser.js'
import edataCustomerAdminApi from './edataCustomerAdmin.js'
import edataCustomerUserApi from './edataCustomerUser.js'

export {
  edataUserApi,
  edataCustomerAdminApi,
  edataCustomerUserApi
}
